import React, { useState, useEffect } from 'react';
import '../../CSS/Global.css';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import Swal from 'sweetalert2';
import MarqueeModal from './MarqueeModal';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Pencil, Trash2 } from 'lucide-react';
import { useSearch } from '../../SearchContext';
import Loader from '../Loader';
import { decryptToken } from '../utils/getToken';

const Marquee = () => {
    const { isSidebarOpen } = useSidebar();
    const url = process.env.REACT_APP_LINK;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [data, setData] = useState({
        heading: "",
        user_id: isLoggedIn.main_id,
        user_name: isLoggedIn.full_name,
    })
    const [slider, setSlider] = useState([])
    const { globalSearch } = useSearch();
    const [load, setLoad] = useState(false);
    const token = decryptToken("accessToken") || ""

    // State Variables
    const [searchQuery, setSearchQuery] = useState('');
    // const [ageGroups, setAgeGroups] = useState([
    //     // Sample data (replace with actual data)
    //     { minAge: 18, maxAge: 25, status: 'Active' },
    //     { minAge: 26, maxAge: 35, status: 'Deactive' },
    //     { minAge: 36, maxAge: 50, status: 'Active' },
    // ]);
    const [filteredAgeGroups, setFilteredAgeGroups] = useState(slider);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    // Effect to handle filtering
    useEffect(() => {
        const filtered = slider.filter((group) =>
            Object.values(group).some((value) =>
                String(value).toLowerCase().includes(globalSearch.toLowerCase())
            )
        );
        setFilteredAgeGroups(filtered);
        setCurrentPage(1); // Reset to first page on new search
    }, [globalSearch, slider]);

    // Pagination Logic
    const totalPages = Math.ceil(filteredAgeGroups.length / itemsPerPage);
    const currentData = filteredAgeGroups.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    // Handlers
    const handleSearch = (e) => setSearchQuery(e.target.value);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    // Toggle Status
    const toggleStatus = (index) => {
        setSlider((prevGroups) =>
            prevGroups.map((group, i) =>
                i === index
                    ? { ...group, status: group.status === 'Active' ? 'Deactive' : 'Active' }
                    : group
            )
        );
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "This will permanently delete the slider!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        });

        if (result.isConfirmed) {
            try {
                const response = await fetch(`${url}/marquee/${id}`, {
                    method: "DELETE",
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                });

                const res = await response.json();

                if (response.ok) {
                    Swal.fire('Deleted!', 'Marquee has been deleted.', 'success');
                    sliderFetch(); // Refresh the slider list
                } else {
                    Swal.fire('Error!', res.message || 'Failed to delete.', 'error');
                }
            } catch (error) {
                Swal.fire('Error!', 'Something went wrong.', 'error');
                console.error(error);
            }
        }
    };
    const sliderFetch = async () => {
        setLoad(true)
        try {
            const response = await fetch(`${url}/marquee/all/${isLoggedIn.main_id}`)
            const res = await response.json();
            console.log(res);
            setSlider(res);
        } catch (error) {
            console.log(error);
        } finally {
            setLoad(false)
        }
    }

    useEffect(() => {
        sliderFetch();
    }, [])

    if (load) {
        return (
            <Loader />
        );
    }

    return (
        <>

            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <div className="oms-header">
                    <h1 className="dashboard-title">Marquee</h1>

                    {/* Add Fees Button */}
                    <button
                        className="oms-add-btn"
                        onClick={() => {
                            // Reset the form to default empty values
                            setData({
                                image: "",
                                title: "",
                                description: "",
                                link: "",
                                offer_name: "",
                                button_name: "",
                                user_id: isLoggedIn.main_id,
                                user_name: isLoggedIn.full_name,
                            });
                            setIsModalOpen(true);
                        }}
                    >
                        Add Marquee
                    </button>

                </div>

                {/* Search Filter */}
                {/* <div className="filter-search">
                    <div className="filter-search-input">
                        <input
                            type="search"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                        />
                        <i className="fa fa-search"></i>
                    </div>
                </div> */}

                {/* Age Groups Table */}
                <div className="customer-table responsive-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Heading</th>
                                {/* <th>Offer</th> */}
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentData.length > 0 ? (
                                currentData.map((group, index) => (
                                    <tr key={index}>
                                        <td>{group.heading || "N/A"}</td>
                                        <td>
                                            <button
                                                className="edit-button"
                                                onClick={() => {
                                                    setData(group); // 👈 preload the selected group's data including `_id`
                                                    setIsModalOpen(true);
                                                }}
                                            >
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>

                                            <button
                                                className="delete-button"
                                                onClick={() => handleDelete(group.id)} // or group._id
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>

                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="4" style={{ textAlign: 'center' }}>
                                        No data found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="ecom-responsive-cards">
                    {currentData.length === 0 ? (
                        <p style={{ textAlign: "center", margin: "50px" }}>No Data Found</p>
                    ) : (
                        currentData.map((group, index) => (
                            <div className="ecom-responsive-card"
                                key={index}>

                                <div className="ecom-responsive-header">
                                    <p onClick={() => {
                                        let parsedProduct = group.product;

                                        try {
                                            // Handle double-stringified product
                                            if (typeof parsedProduct === "string") {
                                                parsedProduct = JSON.parse(parsedProduct);
                                                if (typeof parsedProduct === "string") {
                                                    parsedProduct = JSON.parse(parsedProduct);
                                                }
                                            }
                                        } catch (e) {
                                            console.warn("Error parsing product:", e);
                                            parsedProduct = {}; // fallback
                                        }

                                        setData({
                                            ...group,
                                            product: parsedProduct,
                                        });

                                        setIsModalOpen(true);
                                    }}><Pencil size={20} /> <span>Edit</span></p>
                                    <p><Trash2 size={20} onClick={() => handleDelete(group.id)} /> <span>Delete</span></p>
                                </div>

                                <div className="ecom-responsive-body">
                                    <div className="ecom-responsive-left">
                                        <h2>{group.heading || "Not Provided"}</h2>
                                        {/* <p><ProductListDisplay products={group.product} /></p> */}
                                        {/* <div className="ecom-card-images">
                                                            <div>
                                                                <p>Main Image</p>
                                                                <img src={group.image} alt="" style={{ width: "50px", height: "50px" }} />
                                                            </div>
                                                            <div>
                                                                <p>Background Image</p>
                                                                <img src={group.background_image} style={{ width: "50px", height: "50px" }} alt="" />
                                                            </div>
                                                        </div> */}
                                    </div>

                                    {/* <div className="ecom-responsive-right">
                                                        <h4>₹{group.price}</h4>
                                                        <p>₹{group.cutOffPrice}</p>
                                                    </div> */}
                                </div>
                            </div>
                        ))
                    )}

                </div>
                {totalPages > 1 && (

                    <div className="pagination">
                        {/* First Page */}
                        <button
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronsLeft size={18} />
                        </button>

                        {/* Previous Page */}
                        <button
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronLeft size={18} />
                        </button>

                        {/* Current Page Number Only */}
                        <button className="pagination-btn active">
                            {currentPage}
                        </button>

                        {/* Next Page */}
                        <button
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronRight size={18} />
                        </button>

                        {/* Last Page */}
                        <button
                            onClick={() => paginate(totalPages)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronsRight size={18} />
                        </button>
                    </div>
                )}

            </div>

            <MarqueeModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} data={data} setData={setData} sliderFetch={sliderFetch} />
        </>
    );
};

export default Marquee;
